import isEmpty from 'lodash.isempty';

export const isNotEmpty = (item) => !isEmpty(item);
